<template>
  <v-card class="pa-0" :color="status.online ? '' : 'red'">
    <v-card-title style="display: flex; justify-content: space-between">
      {{ status.authorizator }} ({{ status.environment_description }})
      <div v-if="status.in_contingency_since" class="text-caption">
        {{ formatFromNow(status.in_contingency_since) }}
      </div>
    </v-card-title>
    <v-card-subtitle class="py-0">
      <span
        class="text-primary d-block"
        :class="{
          'text-truncate': !show,
        }"
      >
        <template v-if="status.online"> Online </template>
        <template v-else-if="status.forced_contingency">
          Contingência forçada
        </template>
        <template v-else-if="status.latest_status">
          {{ status.latest_status }}
        </template>
        <template v-else> Operando em contingência </template>
      </span>
    </v-card-subtitle>
    <v-card-actions class="mt-0 pt-0">
      <v-spacer />

      <v-btn icon @click="show = !show">
        <v-icon :icon="show ? mdiChevronUp : mdiChevronDown" />
      </v-btn>
    </v-card-actions>

    <v-expand-transition>
      <v-card-text v-show="show">
        <div v-if="status.online && !status.forced_contingency">
          <v-btn
            block
            color="accent"
            @click="forceContingency"
            :loading="loading"
            :disabled="!$can('nfce:force_contingency')"
          >
            Forçar modo contingência
          </v-btn>
        </div>
        <div v-else-if="!status.online && status.forced_contingency">
          <v-btn
            block
            color="accent"
            @click="clearContingency"
            :loading="loading"
            :disabled="!$can('nfce:force_contingency')"
          >
            Remover modo contingência
          </v-btn>
        </div>
        <template v-if="!status.online">
          <v-divider class="mt-3 mb-2" />
          <div>Última checagem: {{ formatFromNow(status.latest_check) }}</div>
        </template>
      </v-card-text>
    </v-expand-transition>
  </v-card>
</template>

<script setup>
import { ref, inject, computed } from "vue";
import { mdiChevronUp, mdiChevronDown } from "@mdi/js";
import { formatFromNow } from "@/composables/useDateFormat";
import {
  useForceContingencyMutation,
  useClearContingencyMutation,
} from "@/queries/modules/sefaz";
import { useSnackbar } from "@/plugins/snackbar";

const props = defineProps({
  status: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["update"]);

const $can = inject("$can");
const $snackbar = useSnackbar();

const show = ref(false);

const forceContingencyMutation = useForceContingencyMutation();
const clearContingencyMutation = useClearContingencyMutation();

const loading = computed(
  () =>
    forceContingencyMutation.isPending.value ||
    clearContingencyMutation.isPending.value,
);

async function forceContingency() {
  try {
    await forceContingencyMutation.mutateAsync({
      authorizator: props.status.authorizator,
      environment: props.status.environment,
    });
    emit("update");
    show.value = false;
  } catch (e) {
    $snackbar.error(`Ocorreu um erro ao realizar a requisição: ${e}`);
  }
}

async function clearContingency() {
  try {
    await clearContingencyMutation.mutateAsync({
      authorizator: props.status.authorizator,
      environment: props.status.environment,
    });
    emit("update");
    show.value = false;
  } catch (e) {
    $snackbar.error(`Ocorreu um erro ao realizar a requisição: ${e}`);
  }
}
</script>
